import {
  U3130_HONORARIUM_NO_PROJECT_KEY,
  u3130CompareHonorariumText,
  type U3130HonorariumProjectGroup,
} from './u3130GroupHonorariumForDisplay';

export type U3130HonorariumSortOrder = 'ASC' | 'DESC';

/** `project` = numéro de dossier (tri par défaut BL-0676). */
export type U3130HonorariumProjectSortField = 'project' | 'customer' | 'natures';

function groupSortKey(group: U3130HonorariumProjectGroup, field: U3130HonorariumProjectSortField): string {
  if (field === 'customer') return group.clientLabel;
  if (field === 'natures') return group.workNatureDisplay;
  return group.projetNumber;
}

/**
 * Trie les dossiers. « Sans projet » et les valeurs vides restent en fin de liste quel que soit le sens.
 * Comparaison numérique (« 9 » avant « 10 »).
 */
export function u3130SortHonorariumProjectGroups(
  groups: U3130HonorariumProjectGroup[],
  field: U3130HonorariumProjectSortField,
  order: U3130HonorariumSortOrder,
): U3130HonorariumProjectGroup[] {
  return [...groups].sort((a, b) => {
    const aNoProject = a.projectKey === U3130_HONORARIUM_NO_PROJECT_KEY;
    const bNoProject = b.projectKey === U3130_HONORARIUM_NO_PROJECT_KEY;
    if (aNoProject !== bNoProject) return aNoProject ? 1 : -1;
    const ka = groupSortKey(a, field);
    const kb = groupSortKey(b, field);
    if (!ka !== !kb) return ka ? -1 : 1;
    const c = u3130CompareHonorariumText(ka, kb);
    if (c !== 0) return order === 'ASC' ? c : -c;
    const tie = u3130CompareHonorariumText(a.projectLabel, b.projectLabel);
    if (tie !== 0) return tie;
    return a.projectKey.localeCompare(b.projectKey);
  });
}